import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import HistoryIcon from "@mui/icons-material/History";
import { makeStyles } from "@mui/styles";

interface Props {
  value: number;
  onChange: (e: React.SyntheticEvent, newVal: number) => void;
}

const useStyles = makeStyles(() => ({
  tabStyle: {
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 600,
    padding: "6px 20px !important",
    minHeight: "35px !important",
    marginTop: "8px !important",
    width: "185px !important",
  },
}));

const MessageTabs: React.FC<Props> = ({ value, onChange }) => {
  const classes = useStyles();

  return (
    <Box>
      <Tabs
        value={value}
        onChange={onChange}
        aria-label="message-tabs"
        variant="standard"
        sx={{
          "& .Mui-selected": {
            bgcolor: "#4aa5dc",
            color: "#ffffff !important",
            borderRadius: "50rem",
          },
          "& .MuiTab-root:not(.Mui-selected)": {
            border: "1px solid #ccc",
            borderColor: "#ccc",
            borderRadius: "50rem",
          },
          "& .MuiTabs-indicator": { width: "0px !important" },
        }}>
        <Tab
          icon={
            <ScheduleIcon fontSize="small" sx={{ width: 18, height: 18 }} />
          }
          iconPosition="start"
          label="Scheduled"
          className={classes.tabStyle}
        />
        <Tab
          icon={<HistoryIcon fontSize="small" sx={{ width: 18, height: 18 }} />}
          iconPosition="start"
          label="Past Messages"
          className={classes.tabStyle}
        />
      </Tabs>
    </Box>
  );
};

export default MessageTabs;
